import { apiClient } from './api.js';

// Dashboard service to replace direct database queries with API calls
export class DashboardService {
    constructor() {
        this.apiClient = apiClient;
    }

    // Get basic dashboard statistics
    async getDashboardStats() {
        return await this.apiClient.getDashboardStats();
    }

    // Get defection distribution by model
    async getDefectionsByModel() {
        return await this.apiClient.getDefectionsByModel();
    }

    // Get defection distribution by type
    async getDefectionsByType() {
        return await this.apiClient.getDefectionsByType();
    }

    // Get defection types (def_defection table)
    async getDefectionTypes() {
        return await this.apiClient.getDefDefections();
    }

    // Placeholder methods for complex queries that need backend implementation
    // These would eventually need corresponding backend endpoints

    async getTaskStatsByMonth() {
        // TODO: Implement backend endpoint for task stats by month
        // Currently returns empty array to prevent errors
        console.warn('getTaskStatsByMonth not yet implemented in backend');
        return [];
    }

    async getFieldItemsWithTurbineCount() {
        // TODO: Implement backend endpoint for field items with turbine counts
        // Currently returns empty array to prevent errors
        console.warn('getFieldItemsWithTurbineCount not yet implemented in backend');
        return [];
    }

    async getDefectionCountByMonth(labelBy = 'human') {
        // TODO: Implement backend endpoint for defection counts by month
        // Currently returns empty array to prevent errors
        console.warn('getDefectionCountByMonth not yet implemented in backend');
        return [];
    }

    async getTurbineStatsByModel() {
        // TODO: Implement backend endpoint for turbine stats by model
        // Currently returns empty array to prevent errors
        console.warn('getTurbineStatsByModel not yet implemented in backend');
        return [];
    }

    async getUserStatsByRole() {
        // TODO: Implement backend endpoint for user stats by role
        // Currently returns empty array to prevent errors
        console.warn('getUserStatsByRole not yet implemented in backend');
        return [];
    }

    async getFieldItemsWithLocation() {
        // TODO: Implement backend endpoint for field items with latitude/longitude
        // Currently returns empty array to prevent errors
        console.warn('getFieldItemsWithLocation not yet implemented in backend');
        return [];
    }

    async getDefectionTypeStatsByMonth(defectionTypeSeq) {
        // TODO: Implement backend endpoint for defection type stats by month
        // Currently returns empty array to prevent errors
        console.warn('getDefectionTypeStatsByMonth not yet implemented in backend');
        return [];
    }
}

// Export singleton instance
export const dashboardService = new DashboardService();
export default dashboardService;